import React from "react";
import type { MenuDataItem } from "@ant-design/pro-components";
import { history } from "@umijs/max";

/**
 * Special menu items configuration
 */
const SPECIAL_MENU_ITEMS = {
  YIZHE_PRINT: "/hangtagCareLabelPrint",
} as const;

/**
 * Yizhe print menu item renderer
 * @param defaultDom Default rendering content
 * @returns Custom Yizhe print menu item
 */
const renderPrintMenuItem = (defaultDom: React.ReactNode): React.ReactNode => {
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        // Trigger global print event
        window.dispatchEvent(new CustomEvent("triggerPrintJump"));
      }}
      style={{ cursor: "pointer" }}
    >
      {defaultDom}
    </div>
  );
};

/**
 * Normal menu item renderer
 * @param menuItemProps Menu item properties
 * @param defaultDom Default rendering content
 * @returns Clickable normal menu item
 */
const renderNormalMenuItem = (
  menuItemProps: MenuDataItem,
  defaultDom: React.ReactNode,
): React.ReactNode => {
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        // Do not respond when disabled
        if (menuItemProps.disabled) return;
        // Navigate if path exists
        if (menuItemProps.path) {
          history.push(menuItemProps.path);
        }
      }}
      style={{ cursor: "pointer" }}
    >
      {defaultDom}
    </div>
  );
};

/**
 * Custom menu item renderer
 * @param menuItemProps Menu item properties
 * @param defaultDom Default rendering content
 * @returns Rendered menu item
 */
export const customMenuItemRenderer = (
  menuItemProps: MenuDataItem,
  defaultDom: React.ReactNode,
): React.ReactNode => {
  // Handle Yizhe print menu item
  if (menuItemProps.path === SPECIAL_MENU_ITEMS.YIZHE_PRINT) {
    return renderPrintMenuItem(defaultDom);
  }

  // Add click navigation for other menu items
  return renderNormalMenuItem(menuItemProps, defaultDom);
};
